import { render, staticRenderFns } from "./brandTendencyDetail.vue?vue&type=template&id=e4fc3a6a&scoped=true&"
import script from "./brandTendencyDetail.vue?vue&type=script&lang=js&"
export * from "./brandTendencyDetail.vue?vue&type=script&lang=js&"
import style0 from "./brandTendencyDetail.vue?vue&type=style&index=0&id=e4fc3a6a&lang=stylus&scoped=true&"
import style1 from "./brandTendencyDetail.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4fc3a6a",
  null
  
)

export default component.exports